import { addToCart } from '@gn-audio/core/api/e-commerce/add-to-cart';
import { element } from 'angular';
import { StaticLocationParamaters } from 'cg-foundation-theming';
import { BundleAnalyzerState } from '../models';
var SolutionPageController = (function () {
    function SolutionPageController($scope, $timeout, $route, lastViewedService, locationService, bundleAnalyzer, promptMessage, cartChannel, locationCartState, compareChannel, cartChannelItems, solutionResult) {
        var _this = this;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$route = $route;
        this.lastViewedService = lastViewedService;
        this.locationService = locationService;
        this.bundleAnalyzer = bundleAnalyzer;
        this.promptMessage = promptMessage;
        this.cartChannel = cartChannel;
        this.locationCartState = locationCartState;
        this.compareChannel = compareChannel;
        var stickyTimeout;
        var htmlWatcher;
        this.$scope.cartChannelItems = cartChannelItems || [];
        this.$scope.redirecting = false;
        this.cartChannel.reInit();
        this.cartChannel.onAdd().then(null, null, function (items) {
            _this.$scope.cartChannelItems.push(items);
            var cartItems = _this.$scope.cartChannelItems.map(function (x) {
                return x.map(function (y) { return String(y.groupId); });
            });
            _this.locationCartState.set(cartItems);
        });
        this.cartChannel.onRemove().then(null, null, function (items) {
            var index = _this.$scope.cartChannelItems.indexOf(items);
            if (index > -1) {
                _this.$scope.cartChannelItems.splice(index, 1);
            }
            var cartItems = _this.$scope.cartChannelItems.map(function (x) {
                return x.map(function (y) { return String(y.groupId); });
            });
            _this.locationCartState.set(cartItems);
        });
        this.$scope.excludedThirdPartyDevices = this.locationService.get(StaticLocationParamaters.thirdPartyProducts, true);
        this.$scope.setStickyOn = false;
        if (solutionResult !== undefined) {
            this.$scope.group = solutionResult.group;
            this.$scope.thirdPartyDevices = solutionResult.thirdPartyProducts;
        }
        this.$scope.getBackToSearchResultsUrl = function () {
            var keys = solutionResult.thirdPartyProducts.map(function (t) { return t.searchKey; });
            return _this.locationService.build('compatibilityguide/gallery', { thirdPartyProducts: keys });
        };
        this.$scope.onDevicesChange = function (devices) {
            _this.compareChannel.reset();
            _this.lastViewedService.addLastViewed(devices);
            _this.locationService.set(StaticLocationParamaters.thirdPartyProducts, devices.map(function (d) { return d.searchKey; }));
            _this.$route.reload();
        };
        this.$scope.onAddToCart = function (items) {
            if (items.length === 0) {
                console.warn('WAT? O_o');
                return;
            }
            var skus = items.map(function (x) { return x.sku; });
            var state = _this.bundleAnalyzer.analyze(_this.$scope.group, items, _this.$scope.thirdPartyDevices);
            switch (state) {
                case BundleAnalyzerState.NoAccessories:
                    _this.promptMessage.create('WarningNoAccessories').then(function () {
                        _this.addToCart(skus);
                    });
                    break;
                case BundleAnalyzerState.OutOfStock:
                    _this.promptMessage.create('WarningOutOfStock').then(function () {
                        var availableSkus = items
                            .filter(function (x) { var _a; return ((_a = x.price) === null || _a === void 0 ? void 0 : _a.availabilityState) < 3; })
                            .map(function (x) { return x.sku; });
                        _this.addToCart(availableSkus);
                    });
                    break;
                case BundleAnalyzerState.DoesNotFit:
                    _this.promptMessage.create('WarningDoesNotFit').then(function () {
                        _this.addToCart(skus);
                    });
                    break;
                case BundleAnalyzerState.Ok:
                default:
                    _this.addToCart(skus);
                    break;
            }
        };
        htmlWatcher = this.$scope.$watch(function () {
            return element('.solution-container')[0].innerHTML;
        }, function () {
            if (stickyTimeout) {
                _this.$timeout.cancel(stickyTimeout);
            }
            stickyTimeout = _this.$timeout(function () {
                _this.$scope.setStickyOn = true;
                htmlWatcher();
            }, 2000);
        });
    }
    SolutionPageController.prototype.addToCart = function (sku) {
        this.$scope.redirecting = true;
        if (typeof BasketEventBus === 'undefined') {
            addToCart(sku);
        }
        else {
            this.$scope.redirecting = false;
            BasketEventBus.post("add-to-basket", sku);
        }
    };
    SolutionPageController.$inject = [
        '$scope',
        '$timeout',
        '$route',
        'lastViewedService',
        'locationService',
        'bundleAnalyzer',
        'promptMessage',
        'cartChannel',
        'locationCartState',
        'compareChannel',
        'cartChannelItems',
        'solutionResult',
    ];
    return SolutionPageController;
}());
export { SolutionPageController };
